const DiiaEnIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 1024 1024"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5018_4686)">
      <path
        d="M511.921 0C287.578 0 162.855 0 81.5069 81.5069C0 162.855 0 287.578 0 511.921C0 736.263 0 860.986 81.5069 942.493C163.014 1024 287.737 1024 512.079 1024C736.422 1024 861.145 1024 942.652 942.493C1024.16 860.986 1024.16 736.263 1024.16 511.921C1024.16 287.578 1024.16 162.855 942.652 81.348C860.986 0 736.263 0 511.921 0Z"
        fill="black"
      />
      <path
        d="M503.818 397.525C503.818 410.871 497.939 421.834 476.807 421.834C456.788 421.834 449.797 411.03 449.797 397.525C449.797 384.179 456.629 373.216 476.807 373.216C497.939 373.216 503.818 384.02 503.818 397.525Z"
        fill="white"
      />
      <path
        d="M492.696 578.651L445.984 610.746L492.219 447.732H408.488L396.572 480.462L445.667 480.144L413.731 596.923C409.759 611.858 414.684 626.316 426.442 634.896C438.358 643.476 454.246 643.476 467.434 634.578L510.809 605.185C506.36 598.512 497.78 585.642 492.696 578.651Z"
        fill="white"
      />
      <path
        d="M185.416 386.244H262.951C295.681 386.244 325.71 397.048 341.439 418.815C357.169 440.582 364.954 472.2 364.954 513.827C364.954 555.454 357.169 587.231 341.439 608.839C325.71 630.606 301.56 641.41 268.83 641.41H185.257V386.244H185.416ZM266.446 607.886C285.195 607.886 299.176 601.53 308.392 588.979C317.607 576.427 322.055 558.473 322.055 535.117V492.537C322.055 469.181 317.448 451.227 308.392 438.517C299.176 425.965 285.354 419.61 266.446 419.61H226.09V607.568H266.446V607.886Z"
        fill="white"
      />
      <path
        d="M730.385 640.774C756.6 640.774 780.433 629.176 793.938 609.792L794.891 608.362L795.209 610.11C798.228 630.129 809.508 639.027 831.752 639.027C837.948 639.027 843.033 638.709 847.005 637.914V599.465H840.332C832.546 599.465 828.574 595.334 828.574 587.231V507.154C828.574 467.592 801.246 443.918 755.329 443.918C724.188 443.918 697.337 454.722 675.57 475.854L700.832 503.658C715.609 488.406 733.562 480.303 752.787 480.303C774.713 480.303 789.012 489.359 789.012 503.341C789.012 516.846 772.489 520.182 749.292 523.201C732.132 525.425 712.431 528.921 697.019 537.977C679.542 548.305 670.962 563.716 670.962 585.324C671.121 618.372 694.954 640.774 730.385 640.774ZM752.628 552.753L754.058 552.435C769.629 549.893 779.638 547.987 786.788 543.538L787.9 542.902V564.034C787.9 587.072 766.133 605.661 739.441 605.661C722.599 605.661 712.431 596.605 712.431 581.193C712.59 560.062 731.973 556.566 752.628 552.753Z"
        fill="white"
      />
      <path
        d="M637.12 397.525C637.12 410.871 631.242 421.834 610.11 421.834C590.091 421.834 583.1 411.03 583.1 397.525C583.1 384.179 589.932 373.216 610.11 373.216C631.083 373.216 637.12 384.02 637.12 397.525Z"
        fill="white"
      />
      <path
        d="M622.98 580.24L579.446 610.746L625.681 447.732H542.744L530.828 480.462L579.128 480.144L547.193 596.923C543.22 611.858 548.146 626.316 559.903 634.896C571.819 643.476 587.708 643.476 600.895 634.578L641.092 606.774C636.644 600.26 628.064 587.39 622.98 580.24Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath>
        <rect width="1024" height="1024" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default DiiaEnIcon;
